import { render, staticRenderFns } from "./ChangelogEntryLog.vue?vue&type=template&id=160bb5ae&scoped=true&"
import script from "./ChangelogEntryLog.vue?vue&type=script&lang=ts&"
export * from "./ChangelogEntryLog.vue?vue&type=script&lang=ts&"
import style0 from "./ChangelogEntryLog.vue?vue&type=style&index=0&id=160bb5ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160bb5ae",
  null
  
)

export default component.exports